import { styled, CSSProperties } from '@nexelem/deprecated-theme';
import { ReactNode } from 'react';

const doubleLineString: CSSProperties = {
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'pre-wrap',
  textOverflow: 'ellipsis',
};

export const LongString = styled('span')(() => {
  return {
    ...doubleLineString,
  };
});

export const LongStringSpan = styled('span')(({ theme }) => {
  return {
    ...theme.typography.sourceSansPro16Regular,
    ...doubleLineString,
  };
});

export const LongStringContainer = ({ children }: { children: ReactNode }) => (
  <div className="flex h-full flex-col items-start justify-center">
    <LongStringSpan>{children}</LongStringSpan>
  </div>
);
